import { render, staticRenderFns } from "./moduleListLight.vue?vue&type=template&id=0fc17254&"
import script from "./moduleListLight.vue?vue&type=script&lang=js&"
export * from "./moduleListLight.vue?vue&type=script&lang=js&"
import style0 from "./moduleListLight.vue?vue&type=style&index=0&id=0fc17254&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports